import * as types from 'actions/types';
import dotProp from 'dot-prop-immutable';

const INITIAL_STATE = {
  ticketRemovalInProcess: [],
};

const display = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_TICKET_REMOVAL_IN_PROCESS:
      if (action.value) {
        return dotProp.set(state, 'ticketRemovalInProcess', [...state.ticketRemovalInProcess, action.ticketId]);
      }

      const arrayWithIdRemoved = [...state.ticketRemovalInProcess].filter((id) => id !== action.ticketId);

      return dotProp.set(state, 'ticketRemovalInProcess', arrayWithIdRemoved);
    default:
      return state;
  }
};

export default display;
